"use client";

import React from "react";
import Link from "next/link";

import { useIsAdLanding } from "@/lib/hooks/useIsAdLanding";
import { NewButton } from "@/components/ui/NewButton";
import { Button } from "@/components/ui/Button";
import type { TrackingId } from "@/lib/tracking";
import type { ButtonConfig } from "@/components/ui/GradientCard";

export function GradientCardButtons({
  buttons,
  buttonTrackingId,
}: {
  buttons: ButtonConfig[];
  buttonTrackingId?: { primaryId?: TrackingId; secondaryId?: TrackingId };
}) {
  const isAdLanding = useIsAdLanding();

  if (isAdLanding) {
    return (
      <div className="flex flex-col sm:flex-row gap-4 items-center">
        <Link href="/book-a-demo" target="_self" data-mixpanel-id="cta-book-a-demo-utm">
          <NewButton variant="accent" size="lg" arrow="grow" className="text-white h-auto text-center">
            Book a Demo
          </NewButton>
        </Link>
      </div>
    );
  }

  
  const isSingleButton = buttons.length === 1;

  return (
    <div className="flex flex-col sm:flex-row gap-4 items-center">
      {buttons.map((button, index) => {
        const isPrimary =
          button.variant === "primary" || (button.variant === undefined && index === 0);
        const trackingId =
          isSingleButton || index === 0
            ? buttonTrackingId?.primaryId || "cta-start-free-trial"
            : buttonTrackingId?.secondaryId || "cta-book-a-demo";

        const commonProps = {
          variant: button.variant,
          size: "lg" as const,
          className: isPrimary ? "text-white h-auto text-center" : button.className,
        };

        if (button.href) {
          return (
            <Link
              key={`${button.href}-${index}`}
              href={button.href}
              target={button.target || "_blank"}
              rel={button.target === "_self" ? undefined : "noopener noreferrer"}
              data-mixpanel-id={trackingId}
            >
              {button.arrow ? (
                <NewButton {...commonProps} arrow={button.arrow}>
                  {button.text}
                </NewButton>
              ) : (
                <Button {...commonProps} asChild>
                  {button.text}
                </Button>
              )}
            </Link>
          );
        }

        return (
          <Link key={`calendly-${index}`} href="/book-a-demo" target="_self" data-mixpanel-id={trackingId}>
            {button.arrow ? (
              <NewButton {...commonProps} arrow={button.arrow}>
                {button.text}
              </NewButton>
            ) : (
              <Button {...commonProps} asChild>
                {button.text}
              </Button>
            )}
          </Link>
        );
      })}
    </div>
  );
}

